/* Chakkiwale configurable product card + drawer (Claude Design v5).
 * Parses real Shopify variant options ("Type" = Whole/Flour–grind/grind/Powder, "Size")
 * into the Form -> Grind -> Size model, then renders a card face + configuration drawer
 * (mobile bottom-sheet / desktop popover). Cart state is derived from /cart.js.
 * One door: the card's green button opens the drawer (or adds directly when there's nothing
 * to choose). The button never becomes a stepper. */
(function () {
  'use strict';
  if (window.ChakkiCardConfigurator) { window.ChakkiCardConfigurator.init(); return; }  // loaded by another section already

  var GRINDS = ['Fine', 'Superfine', 'Coarse', 'Laddu Coarse'];
  var RE_TYPE = /type|grind|form/i;
  var RE_SIZE = /size|weight|pack|volume/i;
  var CUE_ICON = { '✓': '✓', '📍': '📍', '🍽': '🍽' };

  function money(paise) {
    var r = Math.round(paise) / 100;
    var s = r % 1 === 0 ? r.toLocaleString('en-IN') : r.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '₹' + s;
  }
  function baseQty(label) {
    var m = String(label || '').toLowerCase().replace(/\s+/g, '').match(/^([\d.]+)(kg|g|ml|l)$/);
    if (!m) return null;
    var n = parseFloat(m[1]);
    if (m[2] === 'g' || m[2] === 'ml') return n / 1000;
    return n;
  }
  function uniq(a) { var s = {}, o = []; a.forEach(function (x) { if (x != null && !s[x]) { s[x] = 1; o.push(x); } }); return o; }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  /* ---------------- cart (derived from /cart.js) ---------------- */
  var Cart = {
    byVariant: {},           // variantId -> { key, qty }
    listeners: [],
    onChange: function (fn) { this.listeners.push(fn); },
    emit: function () { this.listeners.forEach(function (f) { f(); }); },
    load: function () {
      var self = this;
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.ingest(cart); return cart; })
        .catch(function () {});
    },
    ingest: function (cart) {
      this.byVariant = {};
      this.items = (cart.items || []).map(function (it) { return { id: it.variant_id, key: it.key, qty: it.quantity }; });   // cart (add) order
      this.items.forEach(function (it) { this.byVariant[it.id] = { key: it.key, qty: it.qty }; }, this);
      this.itemCount = cart.item_count;
      this.emit();
      document.querySelectorAll('.js-cart-count, [data-cart-count]').forEach(function (e) { e.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      // rebuild the theme's cart drawer CONTENT (generateCart does not open it;
      // updateElements would add the 'active' class and pop the drawer on every load)
      try {
        if (window.theme && theme.miniCart && theme.miniCart.generateCart) theme.miniCart.generateCart();
      } catch (e) {}
    },
    add: function (variantId) {
      var self = this;
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); })  // sold out between tap -> reject
        .then(function () { return self.load(); });
    },
    setQty: function (variantId, qty) {
      var line = this.byVariant[variantId];
      if (!line && qty <= 0) return Promise.resolve();
      var self = this;
      var id = line ? line.key : variantId;
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: Math.max(0, qty) }) })
        .then(function (r) { return r.json(); }).then(function (cart) { self.ingest(cart); });
    },
    qtyOf: function (variantId) { var l = this.byVariant[variantId]; return l ? l.qty : 0; }
  };

  /* ---------------- parse a product into the axis model ---------------- */
  function parseType(raw) {
    var parts = String(raw).split(/\s[–—-]\s/);
    if (parts.length >= 2) return { form: parts[0].trim(), grind: parts.slice(1).join(' ').trim() };
    var t = String(raw).trim();
    if (GRINDS.indexOf(t) !== -1) return { form: null, grind: t };
    return { form: t, grind: null };
  }
  function parseProduct(data) {
    var names = data.options || [];
    var ti = -1, si = -1;
    names.forEach(function (n, i) { if (ti === -1 && RE_TYPE.test(n)) ti = i; else if (si === -1 && RE_SIZE.test(n)) si = i; });
    var variants = data.variants.map(function (v) {
      var form = null, grind = null, size = null;
      if (ti > -1) { var p = parseType(v.opts[ti]); form = p.form; grind = p.grind; }
      if (si > -1) size = v.opts[si];
      return { id: v.id, form: form, grind: grind, size: size, price: v.price, available: v.available, qty: v.qty, tracked: !!v.tracked };
    });
    var forms = uniq(variants.map(function (v) { return v.form; }));
    var grinds = GRINDS.filter(function (g) { return variants.some(function (v) { return v.grind === g; }); });
    var sizes = uniq(variants.map(function (v) { return v.size; }));
    var hasForm = forms.length >= 2;
    var unit = sizes.some(function (s) { return /(^|\d)(ml|l)$/i.test(String(s).replace(/\s+/g, '')); }) ? 'L' : 'kg';
    var def = variants.filter(function (v) { return v.id === data.defaultVariantId; })[0] || variants[0];
    return {
      raw: data, names: names, variants: variants, forms: forms, grinds: grinds, sizes: sizes,
      hasForm: hasForm, hasSize: si > -1, unit: unit, def: def,
      formLabel: (ti > -1 ? names[ti] : 'Form'),
      needsGrind: function (form) {
        if (this.grinds.length === 0) return false;
        if (!this.hasForm) return true;
        return this.variants.some(function (v) { return v.form === form && v.grind != null; });
      },
      sizesFor: function (form, grind) {
        var self = this;
        return uniq(this.variants.filter(function (v) {
          if (self.hasForm && v.form !== form) return false;
          if (grind != null && v.grind !== grind) return false;
          if (grind == null && self.needsGrind(form)) return false;
          return true;
        }).map(function (v) { return v.size; }));
      },
      variantFor: function (form, grind, size) {
        return this.variants.filter(function (v) {
          return (v.form || null) === (form || null) && (v.grind || null) === (grind || null) && (v.size || null) === (size || null);
        })[0] || null;
      },
      per100: function (price, size) { var b = baseQty(size); return b ? price / (b * 10) : null; },
      unitSuffix: function () { return this.unit === 'L' ? '/100ml' : '/100g'; }
    };
  }

  /* ---------------- one card ---------------- */
  function Card(root) {
    if (root.__cfg) return;
    root.__cfg = this;
    this.root = root;
    var d = JSON.parse(root.querySelector('.cfg-data').textContent);
    this.data = d;
    this.model = parseProduct(d);
    this.sel = {};
    this.last = null;
    this.open = false;
    this.undo = null;
    this.undoTimer = null;
    this.variantIds = {};
    this.model.variants.forEach(function (v) { this.variantIds[v.id] = true; }, this);

    // milled badge (JS-derived when server didn't flag)
    if (this.model.grinds.length && root.querySelector('.cfg-badge')) root.querySelector('.cfg-badge').hidden = false;

    this.primary = root.querySelector('.cfg-primary');
    this.primary.addEventListener('click', this.onPrimary.bind(this));
    Cart.onChange(this.renderFace.bind(this));
    this.renderFace();
  }

  Card.prototype.resolve = function () {
    var m = this.model, base = this.sel;
    var form = m.hasForm ? (base.form != null ? base.form : (m.def.form || m.forms[0])) : null;
    var ng = m.needsGrind(form);
    var grind = ng ? (base.grind != null ? base.grind : (m.def.grind || m.grinds[0])) : null;
    var sizes = m.sizesFor(form, grind);
    var size = base.size !== undefined ? base.size : m.def.size;
    if (size && sizes.indexOf(size) === -1) size = null;
    if (sizes.length === 1) size = sizes[0];
    var variant = size != null || !m.hasSize ? m.variantFor(form, grind, size) : null;
    var complete = (!m.hasForm || form != null) && (!ng || grind != null) && (!m.hasSize || size != null);
    return { form: form, grind: grind, size: size, ng: ng, sizes: sizes, variant: variant, complete: complete };
  };

  /* my cart lines, in add order (cart order) */
  Card.prototype.myLines = function () {                   // in cart (add) order — last entry is most recent
    var byId = {};
    this.model.variants.forEach(function (v) { byId[v.id] = v; });
    return (Cart.items || []).filter(function (it) { return byId[it.id] && it.qty > 0; }).map(function (it) { return { v: byId[it.id], qty: it.qty }; });
  };
  Card.prototype.labelFor = function (v) {
    return [v.form, v.grind, v.size].filter(Boolean).join(' · ');
  };

  /* ---------- card face (4 fixed children; cart state = image overlay + tint) ---------- */
  Card.prototype.renderFace = function () {
    var pv = this.root.querySelector('.cfg-price-val');           // clearer pricing: "From ₹X" when it varies
    if (pv && this.model.def) {
      if (this.data.configurable) { var min = Math.min.apply(null, this.model.variants.map(function (v) { return v.price; })); pv.textContent = 'From ' + money(min); }
      else pv.textContent = money(this.model.def.price);
    }
    var prim = this.root.querySelector('.cfg-primary');
    if (prim && !this.data.configurable && this.model.def) {      // OOS single-variant -> Sold out, not a failing Add
      if (!this.model.def.available) { prim.textContent = 'Sold out'; prim.disabled = true; prim.classList.add('cfg-soldout'); }
      else { prim.textContent = 'Add · ' + money(this.model.def.price); prim.disabled = false; prim.classList.remove('cfg-soldout'); }
    }
    var lines = this.myLines();
    var strip = this.root.querySelector('.cfg-cart-strip');
    strip.innerHTML = '';
    if (lines.length) {
      this.root.classList.add('has-lines');
      strip.hidden = false;
      var recent = null;                                   // most recently added this session, else last cart line
      if (this.lastAddedId) recent = lines.filter(function (l) { return l.v.id === this.lastAddedId; }, this)[0];
      if (!recent) recent = lines[lines.length - 1];
      strip.appendChild(el('span', 'cfg-strip-tick', '✓'));
      strip.appendChild(el('span', 'cfg-strip-label', this.stripLabel(recent)));
      if (lines.length > 1) strip.appendChild(el('span', 'cfg-strip-more', '+' + (lines.length - 1)));
    } else {
      this.root.classList.remove('has-lines');
      strip.hidden = true;
    }
    if (this.open) this.renderDrawerBody();
  };

  // band label: drop the form when a grind is present; omit ×1; "N in cart" for no-options
  Card.prototype.stripLabel = function (ln) {
    if (!this.data.configurable) return ln.qty + ' in cart';
    var v = ln.v;
    var parts = (v.grind ? [v.grind, v.size] : [v.form, v.size]).filter(Boolean);
    var s = parts.join(' · ');
    if (ln.qty > 1) s += ' × ' + ln.qty;
    return s;
  };

  Card.prototype.dec = function (v, qty) {
    if (qty <= 1) {
      var label = this.labelFor(v);
      var self = this;
      Cart.setQty(v.id, 0).then(function () {
        self.undo = { variantId: v.id, qty: qty, label: label };
        clearTimeout(self.undoTimer);
        self.undoTimer = setTimeout(function () { self.undo = null; if (self.open) self.renderDrawerBody(); }, 5000);  // undo lives in the drawer now
        self.renderFace();
      });
    } else { Cart.setQty(v.id, qty - 1); }
  };

  Card.prototype.drawerUndoEl = function () {
    var u = el('div', 'cfg-drawer-undo');
    u.appendChild(el('span', 'cfg-undo-text', 'Removed ' + this.undo.label));
    var b = el('button', 'cfg-undo-btn', 'Undo');
    b.addEventListener('click', this.doUndo.bind(this));
    u.appendChild(b);
    return u;
  };
  Card.prototype.doUndo = function () {
    if (!this.undo) return;
    var u = this.undo; this.undo = null; clearTimeout(this.undoTimer);
    Cart.setQty(u.variantId, u.qty);
  };

  /* ---------- primary button ---------- */
  Card.prototype.onPrimary = function () {
    if (!this.data.configurable) {
      if (this.busy) return;                                 // debounce
      var self = this, prim = this.root.querySelector('.cfg-primary');
      if (prim.disabled) return;
      this.busy = true; prim.classList.add('cfg-loading');
      Cart.add(this.data.defaultVariantId)
        .then(function () { self.busy = false; prim.classList.remove('cfg-loading'); })
        .catch(function () {
          self.busy = false; prim.classList.remove('cfg-loading');
          try { if (window.theme && theme.alert) theme.alert.new('', 'Sorry, that just sold out.', 3000, 'warning'); } catch (e) {}
          Cart.load();                                       // re-sync -> button flips to Sold out if now OOS
        });
      return;
    }
    this.openDrawer();
  };
  Card.prototype.openDrawer = function () {
    document.querySelectorAll('.cfg-card.is-open').forEach(function (c) { if (c.__cfg) c.__cfg.closeDrawer(); });  // close all (incl. self) for a clean rebuild
    this.open = true;
    this.sel = this.last ? { form: this.last.form, grind: this.last.grind, size: this.last.size } : {};
    this.undo = null;
    this.switchFrom = null;
    this.root.classList.add('is-open');
    document.body.classList.add('cfg-drawer-open');
    if (this.isMobile()) { this._prevOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
    this._returnFocus = document.activeElement;
    this.buildDrawerShell();
    this.renderDrawerBody();
    var host = this.drawerEl();
    var firstChip = host && host.querySelector('.cfg-chip:not([disabled])');
    if (firstChip) firstChip.focus();
  };
  Card.prototype.closeDrawer = function () {
    if (this.open && this._returnFocus && this._returnFocus.focus) { try { this._returnFocus.focus(); } catch (e) {} }
    this.open = false;
    this.root.classList.remove('is-open');
    document.body.classList.remove('cfg-drawer-open');
    if (this._prevOverflow !== undefined) { document.body.style.overflow = this._prevOverflow; this._prevOverflow = undefined; }
    var panel = this.root.querySelector('.cfg-panel'); if (panel) panel.remove();
    var sheet = document.getElementById('cfg-sheet-root'); if (sheet) sheet.remove();
    var catcher = document.getElementById('cfg-catcher'); if (catcher) catcher.remove();
  };

  Card.prototype.isMobile = function () { return window.matchMedia('(max-width: 767px)').matches; };

  Card.prototype.buildDrawerShell = function () {
    var self = this;
    if (this.isMobile()) {
      var rootEl = el('div'); rootEl.id = 'cfg-sheet-root'; rootEl.className = 'cfg-sheet-root';
      var scrim = el('div', 'cfg-scrim'); scrim.addEventListener('click', function () { self.closeDrawer(); });
      var wrap = el('div', 'cfg-sheet-wrap');
      var fab = el('button', 'cfg-close-fab', '✕'); fab.setAttribute('aria-label', 'Close'); fab.addEventListener('click', function () { self.closeDrawer(); });
      var sheet = el('div', 'cfg-sheet cfg-drawer'); sheet.id = 'cfg-sheet';
      wrap.appendChild(fab); wrap.appendChild(sheet);
      rootEl.appendChild(scrim); rootEl.appendChild(wrap);
      document.body.appendChild(rootEl);
      if (this.data.image) sheet.style.setProperty('--cfg-media-tint', 'transparent');
    } else {
      if (!document.getElementById('cfg-catcher')) {
        var catcher = el('div', 'cfg-desktop-catcher'); catcher.id = 'cfg-catcher';
        catcher.addEventListener('click', function () { self.closeDrawer(); });
        document.body.appendChild(catcher);
      }
      var panel = el('div', 'cfg-panel cfg-drawer');
      var inner = el('div', 'cfg-panel-inner');
      panel.appendChild(inner);
      this.root.appendChild(panel);                        // absolute; positioned against the card (position:relative)
    }
  };

  Card.prototype.drawerEl = function () {
    return this.isMobile() ? document.getElementById('cfg-sheet') : this.root.querySelector('.cfg-panel-inner');
  };

  /* ---------- drawer body ---------- */
  Card.prototype.renderDrawerBody = function () {
    var host = this.drawerEl();
    if (!host) return;
    host.innerHTML = '';
    var mobile = this.isMobile();
    var r = this.resolve();

    if (mobile) {
      var head = el('div', 'cfg-sheet-head');
      var thumb = el('div', 'cfg-sheet-thumb');
      if (this.data.image) { var im = new Image(); im.src = this.data.image; im.alt = ''; thumb.appendChild(im); }
      head.appendChild(thumb);
      var ht = el('div', 'cfg-sheet-head-txt');
      ht.appendChild(el('span', 'cfg-sh-name', this.data.title));
      if (this.data.hero) ht.appendChild(el('span', 'cfg-sh-hero', this.data.hero));
      head.appendChild(ht);
      host.appendChild(head);
    } else {
      var ph = el('div', 'cfg-panel-head');
      ph.appendChild(el('span', 'cfg-ph-title', 'Choose your option'));
      var x = el('button', 'cfg-ph-close', '✕'); x.setAttribute('aria-label', 'Close');
      x.addEventListener('click', this.closeDrawer.bind(this));
      ph.appendChild(x);
      host.appendChild(ph);
    }

    var body = el('div', mobile ? 'cfg-sheet-body' : 'cfg-panel-body');

    // quality cues
    if (this.data.cues && this.data.cues.length) {
      var cues = el('div', 'cfg-cues');
      this.data.cues.forEach(function (c) {
        var line = el('div', 'cfg-cue');
        var s = String(c);
        var isCheck = /^\s*[✓✔]/.test(s);
        // strip leading markers incl. emoji surrogate pairs + variation selectors (they render as boxes)
        var text = s.replace(/^[\s✓✔📍🍽•·\-\uD800-\uDFFF️]+/, '');
        if (isCheck) line.appendChild(el('span', 'cfg-cue-ic', '✓'));
        line.appendChild(el('span', null, text || s));
        cues.appendChild(line);
      });
      body.appendChild(cues);
    }

    // option rows: Form -> Grind -> Size
    if (this.model.hasForm) body.appendChild(this.chipRow('form', this.model.formLabel, this.model.forms, r));
    if (r.ng) body.appendChild(this.chipRow('grind', 'Grind', this.model.grinds, r));
    if (this.model.hasSize) body.appendChild(this.chipRow('size', 'Pack size', r.sizes, r));

    // in-cart list
    var lines = this.myLines();
    if (lines.length) body.appendChild(this.inCartList(lines, r));

    host.appendChild(body);
    if (this.undo) host.appendChild(this.drawerUndoEl());  // undo sits directly above the pinned footer
    host.appendChild(this.footer(r));
    if (this._refocus) {                                   // return focus to the chip the user just changed
      var rf = this._refocus; this._refocus = null;
      var arow = host.querySelector('.cfg-optrow[data-axis="' + rf.axis + '"]');
      if (arow) {
        var chip = [].slice.call(arow.querySelectorAll('.cfg-chip')).filter(function (c) { return c.querySelector('.cfg-chip-l1').textContent.replace('✓ ', '') === rf.val; })[0];
        if (chip) { chip.tabIndex = 0; chip.focus(); }
      }
    }
  };

  Card.prototype.chipRow = function (axis, label, values, r) {
    var self = this, m = this.model;
    var row = el('div', 'cfg-optrow'); row.setAttribute('data-axis', axis);
    row.appendChild(el('div', 'cfg-optlabel', label));
    var group = el('div', 'cfg-chips'); group.setAttribute('role', 'radiogroup'); group.setAttribute('aria-label', label);

    // best value (size row only, when a genuine saving exists)
    var best = null;
    if (axis === 'size') {
      var rates = values.map(function (s) { return m.per100(self.priceOf(r.form, r.grind, s), s); }).filter(function (x) { return x != null; });
      if (rates.length) { var mn = Math.min.apply(null, rates), mx = Math.max.apply(null, rates); if (mn < mx) best = mn; }
    }

    values.forEach(function (val) {
      var sel = axis === 'form' ? r.form === val : axis === 'grind' ? r.grind === val : r.size === val;
      var oos = self.axisOOS(axis, val, r);
      var chip = el('button', 'cfg-chip' + (sel ? ' is-selected' : '') + (oos ? ' is-oos' : ''));
      chip.setAttribute('role', 'radio'); chip.setAttribute('aria-checked', sel ? 'true' : 'false');
      if (oos) { chip.disabled = true; chip.setAttribute('aria-disabled', 'true'); }
      chip.appendChild(el('span', 'cfg-chip-l1', (sel ? '✓ ' : '') + val));
      if (axis === 'size') {
        var price = self.priceOf(r.form, r.grind, val);
        chip.appendChild(el('span', 'cfg-chip-l2', money(price)));
        var rate = m.per100(price, val);
        var sub;
        if (oos) sub = 'Out of stock';
        else if (best != null && rate === best) sub = money(rate) + m.unitSuffix() + ' · best value';
        else if (rate != null) sub = money(rate) + m.unitSuffix();
        if (sub) { var s3 = el('span', 'cfg-chip-l3' + (best != null && rate === best && !oos ? ' is-best' : ''), sub); chip.appendChild(s3); }
      } else if (axis === 'grind' && val === (m.def.grind || m.grinds[0]) && !oos) {
        chip.appendChild(el('span', 'cfg-chip-l3', 'Most bought'));
      } else if (oos) {
        chip.appendChild(el('span', 'cfg-chip-l3', 'Out of stock'));
      }
      if (!oos) chip.addEventListener('click', function () { self._refocus = { axis: axis, val: val }; self.pick(axis, val); });
      group.appendChild(chip);
    });
    // radiogroup keyboard: roving tabindex + arrow-key movement
    var chips = [].slice.call(group.querySelectorAll('.cfg-chip'));
    var focusable = chips.filter(function (c) { return !c.disabled; });
    chips.forEach(function (c) { c.tabIndex = c.classList.contains('is-selected') ? 0 : -1; });
    if (!group.querySelector('.cfg-chip.is-selected[tabindex="0"]') && focusable[0]) focusable[0].tabIndex = 0;
    group.addEventListener('keydown', function (e) {
      var i = focusable.indexOf(document.activeElement);
      if (i === -1 || !focusable.length) return;
      var n = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % focusable.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + focusable.length) % focusable.length;
      if (n > -1) { e.preventDefault(); focusable.forEach(function (c) { c.tabIndex = -1; }); focusable[n].tabIndex = 0; focusable[n].focus(); }
    });
    row.appendChild(group);
    return row;
  };

  // price of the variant nearest (form,grind,size) — used for size-chip prices before final resolve
  Card.prototype.priceOf = function (form, grind, size) {
    var v = this.model.variantFor(form, grind, size);
    if (v) return v.price;
    // fall back: any variant with this size
    var alt = this.model.variants.filter(function (x) { return x.size === size; })[0];
    return alt ? alt.price : this.model.def.price;
  };

  // is this axis value unavailable?  earlier rows: enabled if any downstream pack exists; size: exact combo in stock
  Card.prototype.axisOOS = function (axis, val, r) {
    var m = this.model;
    if (axis === 'size') { var v = m.variantFor(r.form, r.grind, val); return !v || !v.available; }
    if (axis === 'form') {
      return !m.variants.some(function (x) { return x.form === val && x.available; });
    }
    if (axis === 'grind') {
      return !m.variants.some(function (x) { return (!m.hasForm || x.form === r.form) && x.grind === val && x.available; });
    }
    return false;
  };

  Card.prototype.pick = function (axis, val) {
    var m = this.model, cur = this.resolve();
    var s = { form: cur.form, grind: cur.grind, size: cur.size };
    s[axis] = val;
    if (axis === 'form') {
      if (m.hasForm && !m.needsGrind(val)) s.grind = null;
      else if (m.grinds.length && s.grind == null) s.grind = m.def.grind || m.grinds[0];
      var ns = m.sizesFor(val, s.grind);
      if (s.size && ns.indexOf(s.size) === -1) s.size = null;
    }
    if (axis === 'grind') {
      var ng2 = m.sizesFor(s.form, val);
      if (s.size && ng2.indexOf(s.size) === -1) s.size = null;
    }
    // a pack no longer sold in the new combination silently clears
    if (axis !== 'size' && s.size) { var vv = m.variantFor(s.form, s.grind, s.size); if (!vv || !vv.available) s.size = null; }
    this.sel = s;
    this.undo = null;
    this.renderDrawerBody();
  };

  Card.prototype.inCartList = function (lines, r) {
    var self = this;
    var wrap = el('div', 'cfg-incart');
    var head = el('div', 'cfg-incart-head');
    head.appendChild(el('span', 'cfg-ic-title', lines.length + (lines.length === 1 ? ' option in cart' : ' options in cart')));
    var subtotal = lines.reduce(function (a, l) { return a + l.v.price * l.qty; }, 0);
    head.appendChild(el('span', 'cfg-ic-total', money(subtotal)));
    wrap.appendChild(head);
    lines.forEach(function (l) {
      var cur = r.variant && r.variant.id === l.v.id;
      var row = el('div', 'cfg-incart-row' + (cur ? ' is-current' : ''));
      var info = el('div', 'cfg-ic-info');
      info.appendChild(el('span', 'cfg-ic-label', self.labelFor(l.v)));
      info.appendChild(el('span', 'cfg-ic-sub', money(l.v.price) + ' each · ' + money(l.v.price * l.qty)));
      row.appendChild(info);
      if (self.data.configurable) {
        var chg = el('button', 'cfg-ic-switch', 'Change');
        chg.setAttribute('aria-label', 'Change ' + self.labelFor(l.v));
        chg.addEventListener('click', self.startSwitch.bind(self, l.v));
        row.appendChild(chg);
      }
      var st = el('div', 'cfg-stepper');
      var minus = el('button', null, '−'); minus.setAttribute('aria-label', 'One fewer');
      var qty = el('span', 'cfg-qty', l.qty);
      var plus = el('button', null, '+'); plus.setAttribute('aria-label', 'One more');
      minus.addEventListener('click', function () { minus.classList.add('cfg-loading'); self.dec(l.v, l.qty); });
      plus.addEventListener('click', function () { plus.classList.add('cfg-loading'); Cart.setQty(l.v.id, l.qty + 1); });
      st.appendChild(minus); st.appendChild(qty); st.appendChild(plus);
      row.appendChild(st);
      wrap.appendChild(row);
    });
    return wrap;
  };

  Card.prototype.footer = function (r) {
    var self = this, m = this.model;
    var foot = el('div', 'cfg-foot');
    var main = el('div', 'cfg-foot-main');
    var total = el('div', 'cfg-total'); total.setAttribute('aria-live', 'polite');
    var out = r.complete && r.variant && !r.variant.available;
    var valid = r.complete && r.variant && r.variant.available;
    var tv = el('div', 'cfg-total-val', valid ? money(r.variant.price) : '—');
    if (!valid) tv.style.color = 'var(--cfg-muted)';
    total.appendChild(tv);
    if (valid && r.size) { var rate = m.per100(r.variant.price, r.size); if (rate != null) total.appendChild(el('div', 'cfg-total-unit', money(rate) + m.unitSuffix())); }
    main.appendChild(total);

    var isSwitch = this.switchFrom && valid && r.variant.id !== this.switchFrom;
    var addLabel = valid ? ((isSwitch ? 'Update · ' : 'Add · ') + money(r.variant.price)) : (this.switchFrom ? 'Update' : 'Add');
    var add = el('button', 'cfg-add', addLabel);
    if (!valid) { add.disabled = true; add.setAttribute('aria-disabled', 'true'); }
    add.addEventListener('click', function () { if (!valid) return; add.classList.add('cfg-loading'); if (isSwitch) self.doSwitch(r); else self.addToCart(r); });
    main.appendChild(add);
    foot.appendChild(main);

    var note = null;
    if (!r.complete) note = { t: 'Choose a pack size to continue.', c: 'is-incomplete' };
    else if (out) note = { t: 'This combination is out of stock.' };
    else if (valid && r.variant.tracked && r.variant.qty > 0 && r.variant.qty <= 5) note = { t: 'Only ' + r.variant.qty + ' left of this pack.' };
    else if (this.switchFrom) note = { t: 'Changing your current line — pick a new option.', c: 'is-incomplete' };
    if (note) foot.appendChild(el('div', 'cfg-footnote ' + (note.c || ''), note.t));
    return foot;
  };

  Card.prototype.addToCart = function (r) {
    if (!r.variant || this.busy) return;                     // debounce double-tap
    var self = this; this.busy = true;
    this.last = { form: r.form, grind: r.grind, size: r.size };
    this.lastAddedId = r.variant.id;
    Cart.add(r.variant.id)
      .then(function () { self.busy = false; self.renderDrawerBody(); })  // drawer stays open; button spinner is the feedback
      .catch(function () { self.busy = false; Cart.load().then(function () { self.renderDrawerBody(); }); });
  };

  // load a cart line into the chips so the customer can change its variant
  Card.prototype.startSwitch = function (v) {
    this.switchFrom = v.id;
    this.sel = { form: v.form, grind: v.grind, size: v.size };
    this._refocus = null;
    this.renderDrawerBody();
  };
  // swap: add the new variant, then remove the line being changed
  Card.prototype.doSwitch = function (r) {
    if (!r.variant || this.busy) return;
    var self = this, oldId = this.switchFrom;
    this.switchFrom = null; this.busy = true;
    this.last = { form: r.form, grind: r.grind, size: r.size };
    this.lastAddedId = r.variant.id;
    Cart.add(r.variant.id)
      .then(function () { return oldId && oldId !== r.variant.id ? Cart.setQty(oldId, 0) : null; })
      .then(function () { self.busy = false; self.renderDrawerBody(); })
      .catch(function () { self.busy = false; Cart.load().then(function () { self.renderDrawerBody(); }); });
  };

  /* ---------------- init ---------------- */
  function init(scope) {
    (scope || document).querySelectorAll('.cfg-card').forEach(function (e) { new Card(e); });
  }
  function boot() { Cart.load().then(function () { init(); }); }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.cfg-card.is-open').forEach(function (c) { if (c.__cfg) c.__cfg.closeDrawer(); });
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('.cfg-card.is-open').forEach(function (c) { if (c.__cfg) { c.__cfg.closeDrawer(); } });
  });
  window.ChakkiCardConfigurator = { init: init, Cart: Cart };
})();
